import React, { useState, useEffect } from 'react';
import dayjs from "dayjs";
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';
import styled, { css } from 'styled-components';
import Layout from '../components/layout';
import { Container, Content, Section, SectionTitle, ContactButton } from '../components/styled';
import useSizeDetector from '../hooks/useSizeDetector';

import TopBackgroundImg from '../assets/images/main/top_background.png';
import MobileTopBackgroundImg from '../assets/images/main/mobile_top_background.png';
import ServiceAtsentImg from '../assets/images/header/service_atsent.svg';
import ServiceReviewaidImg from '../assets/images/header/service_reviewaid.svg';
import PreviewReviewaidImg from '../assets/images/main/preview_reviewaid.png';
import PreviewAtsentImg from '../assets/images/main/preview_atsent.png';
import PartnerBonAngelsImg from '../assets/images/main/partner_bon_angels.png';
import PartnerCoontecImg from '../assets/images/main/partner_coontec.png';
import PartnerBlockoImg from '../assets/images/main/partner_blocko.png';
import PartnerBagelCodeImg from '../assets/images/main/partner_bagel_code.png';
import PartnerDevRoosImg from '../assets/images/main/partner_dev_roos.png';
import Announcement from "../assets/images/main/announcement.png"

import ChannelService from '../components/channel'

const Main = () => {
	const { isDesktop, Desktop, Mobile } = useSizeDetector();
	const [ready, setReady] = useState(false);
	const [isShow, setIsSHow] = useState(() => {
		let popupDisplayTime = false
		if (typeof window !== 'undefined') {
			popupDisplayTime = localStorage.getItem('popup-display-time');
		}

		if(!popupDisplayTime){
			return true
		} else {
			const targetDate = dayjs(popupDisplayTime);
			return dayjs().isAfter(targetDate, 'day');
		}
	})
	useEffect(() => {
		setReady(true);
        ChannelService.boot({
          "pluginKey": "f16b2776-23fb-4736-859f-5cf88f46832e"
        });
	}, []);

	return (
		ready && (
			<Layout>
				<Helmet>
					<meta property="og:type" content="website" />
					<meta property="og:url" content="https://www.onmydev.com" />
					<meta property="og:title" content="온마이뎁" />
					<meta property="og:image" content="https://s3.ap-northeast-2.amazonaws.com/cdn.atsent.ai/reviewaid.png" />
					<meta property="og:description" content="온마이뎁은 사용자 감성 분석 서비스를 제공합니다." />
					<meta property="og:site_name" content="온마이뎁" />
					<meta property="og:locale" content="ko_KR" />

					<meta name="title" content="온마이뎁 | 사용자 감성 분석 서비스를 제공합니다." />
					<meta name="author" content="onmydev" />
                    <meta name="keywords" content="온마이뎁,onmydev,리뷰에이드,reviewaid,엣센트,엣샌트,atsent,ai,감성분석,리뷰분석,리뷰,리뷰 솔루션" />
                    <meta name="description" content="온마이뎁은 사용자 감성 분석 서비스를 제공합니다." />
                    <meta property="twitter:domain" content="www.onmydev.com" />
                    <meta property="twitter:url" content="https://www.onmydev.com" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content="온마이뎁 | 사용자 감성 분석 서비스를 제공합니다." />
                    <meta name="twitter:description" content="온마이뎁은 사용자 감성 분석 서비스를 제공합니다." />
                    <meta name="twitter:image" content="https://s3.ap-northeast-2.amazonaws.com/cdn.atsent.ai/reviewaid.png" />

					<meta charset="utf-8" />
					<title>온마이뎁 | 사용자 감성 분석 서비스를 제공합니다.</title>
					<link rel="canonical" href="https://www.onmydev.com" />
					<link rel="shortcut icon" href="/favicon.ico" />
					<link rel="icon" type="image/png" href="/favicon-16x16.png" sizes="16x16" />
					<link rel="icon" type="image/png" href="/favicon-32x32.png" sizes="32x32" />
					<link rel="icon" type="image/png" href="/favicon-96x96.png" sizes="96x96" />
				</Helmet>
				<Container>
					<TopCarousel>
						<ContentVerticalCenter>
							<TopCarouselTitle>
								사용자 피드백 감성 분석으로
								<br />
								비즈니스를 개선해보세요!
							</TopCarouselTitle>
							<Mobile>
								<MobileTopButtonContainer>
									<ServiceButton onClick={() => window.open('https://www.atsent.ai/')}>
										<ServiceLogo src={ServiceAtsentImg} />
									</ServiceButton>
									<ServiceButton onClick={() => window.open('https://www.reviewaid.ai/')}>
										<ServiceLogo src={ServiceReviewaidImg} />
									</ServiceButton>
								</MobileTopButtonContainer>
							</Mobile>
						</ContentVerticalCenter>
					</TopCarousel>
					<Section>
						<Content>
							<Row flexDirection={isDesktop ? null : 'column-reverse'}>
								<Column>
									<PreviewReviewAid src={PreviewReviewaidImg} />
								</Column>
								<Column paddingLeft={isDesktop ? '70px' : ''}>
									<SubTitle>리뷰 기반 마케팅 솔루션, 리뷰에이드</SubTitle>
									<Description>
										<Desktop>
											AI가 리뷰를 효과적으로 요약하여 구매전환율을 높입니다.
											<br />
											카카오, 네이버가 사용하는 고급 AI기술을 우리 쇼핑몰에도 적용하세요.
										</Desktop>
										<Mobile>
											AI가 리뷰를 효과적으로 요약하여
											<br />
											구매전환율을 높입니다.
											<br />
											카카오, 네이버가 사용하는 고급 AI기술을
											<br />
											우리 쇼핑몰에도 적용하세요.
										</Mobile>
									</Description>
									<More>
										<Link to="/reviewaid">{`더 알아보기 >`}</Link>
									</More>
								</Column>
							</Row>
							<Row flexDirection={isDesktop ? '' : 'column'}>
								<Column paddingLeft={isDesktop ? '20px' : ''}>
									<SubTitle>감성 데이터 분석 서비스, 엣센트</SubTitle>
									<Description>
										<Desktop>
											비즈니스에 꼭 맞는 요소별 감성 분석을 통해 비지니스를 개선하세요.
											<br />
											사용자의 피드백을 수집하여 숨겨진 의도를 파악하고,
											<br />
											서비스의 개선점을 찾습니다.
										</Desktop>
										<Mobile>
											비즈니스에 꼭 맞는 요소별 감성 분석을 통해
											<br />
											비즈니스를 개선하세요.
											<br />
											사용자의 피드백을 수집하여 숨겨진 의도를 파악하고
											<br />
											서비스의 개선점을 찾습니다.
										</Mobile>
									</Description>
									<More>
										<Link to="/atsent">{`더 알아보기 >`}</Link>
									</More>
								</Column>
								<Column>
									<PreviewAtsent src={PreviewAtsentImg} />
								</Column>
							</Row>
						</Content>
					</Section>
					<Section backgroundColor={'#f7f9fb'} paddingBottom={isDesktop ? '100px' : ''}>
						<Content>
							<SectionTitle>
								<Desktop>사용자 피드백 감성 분석 전문 SaaS 온마이뎁</Desktop>
								<Mobile>
									사용자 피드백 감성 분석 전문
									<br />
									SaaS 온마이뎁
								</Mobile>
							</SectionTitle>
							<OnMyDevCardContainer>
								<Card large>
									<CardIcon>📊</CardIcon>
									<CardTitle>Result</CardTitle>
									<CardSubTitle>결과물이 나오는 서비스를 지향</CardSubTitle>
									<CardDescription>
										분석 결과물이 고객경험을
										<br />
										개선시킬 수 있어야 합니다.
									</CardDescription>
								</Card>
								<Card large>
									<CardIcon>📢</CardIcon>
									<CardTitle>CX</CardTitle>
									<CardSubTitle>사용자 경험에 집중</CardSubTitle>
									<CardDescription>
										사용자의 피드백을 통해
										<br />
										교류하고 고객 경험을
										<br />
										개선할 수 있도록 도와드립니다.
									</CardDescription>
								</Card>
								<Card large>
									<CardIcon>💻</CardIcon>
									<CardTitle>Automation</CardTitle>
									<CardSubTitle>자동화는 분석의 핵심</CardSubTitle>
									<CardDescription>
										복잡한 SDK와 프로젝트가 아닌
										<br />
										마음만 먹으면 바로 할 수 있는
										<br />
										서비스를 지향합니다.
									</CardDescription>
								</Card>
							</OnMyDevCardContainer>
						</Content>
					</Section>
					<Section paddingBottom={isDesktop ? '130px' : ''}>
						<Content>
							<SectionTitle>온마이뎁과 함께합니다</SectionTitle>
							<PartnerCardContainer>
								<Desktop>
									<Card small>
										<PartnerLogo src={PartnerBonAngelsImg} />
									</Card>
									<Card small>
										<PartnerLogo src={PartnerCoontecImg} />
									</Card>
									<Card small>
										<PartnerLogo src={PartnerBlockoImg} />
									</Card>
									<Card small>
										<PartnerLogo src={PartnerBagelCodeImg} />
									</Card>
									<Card small>
										<PartnerLogo src={PartnerDevRoosImg} />
									</Card>
								</Desktop>
								<Mobile>
									<MobileCardRow>
										<Card small>
											<PartnerLogo src={PartnerBonAngelsImg} />
										</Card>
										<Card small>
											<PartnerLogo src={PartnerCoontecImg} />
										</Card>
									</MobileCardRow>
									<MobileCardRow>
										<Card small>
											<PartnerLogo src={PartnerBlockoImg} />
										</Card>
										<Card small>
											<PartnerLogo src={PartnerBagelCodeImg} />
										</Card>
									</MobileCardRow>
									<MobileCardRow>
										<Card small>
											<PartnerLogo src={PartnerDevRoosImg} />
										</Card>
									</MobileCardRow>
								</Mobile>
							</PartnerCardContainer>
						</Content>
					</Section>
					<Section backgroundColor={'#f7f9fb'}>
						<Content>
							<SectionTitle>온마이뎁에 대해 더 궁금하시다면</SectionTitle>
							<ContactButton onClick={() => window.open('https://reviewaid.channel.io/lounge')}>
								문의해주세요
							</ContactButton>
						</Content>
					</Section>
					{
						isShow && (
							<PopUp>
								<img src={Announcement} alt={""}/>
								<div>
									<button onClick={() => {
										setIsSHow(false);
										localStorage.setItem('popup-display-time', new Date())
									}}>오늘 그만 보기
									</button>
									<button onClick={() => setIsSHow(false)}>닫기</button>
								</div>
								<svg onClick={() => setIsSHow(false)} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M9.14258 9.14307L22.8569 22.8574" stroke="#9A9A9A" strokeWidth="1.5" strokeLinecap="round"
												strokeLinejoin="round"/>
									<path d="M9.14258 22.8574L22.8569 9.14314" stroke="#9A9A9A" strokeWidth="1.5" strokeLinecap="round"
												strokeLinejoin="round"/>
								</svg>
							</PopUp>
						)
					}
				</Container>
			</Layout>
		)
	);
};


const PopUp = styled.div`
	position: fixed;
	display: grid;
	top: 100px;
	left: 50%;
	background-color: white;
	border-radius: 8px;
	transform: translateX(-50%);
	z-index: 999;
	box-shadow: 0 0 20px 0 #00000040;

	img {
		width: 100%;
	}

	div {
		display: flex;
		justify-content: space-between;
		border-top: 1px solid #CDCDCD;
		button {
			all: unset;
			font-weight: 500;
			cursor: pointer;
		}
	}
	
	svg {
		position: fixed;
		cursor: pointer;
	}

	@media only screen and (min-width: 768px) {
		grid-auto-columns: 700px;
		grid-template-rows: 1fr 56px;
		
		div > button {
			padding: 0 32px;
			font-size: 16px;
			line-height: 24px;
		}
		svg {
			top: 32px;
			right: 32px;
		}
	}

	@media only screen and (max-width: 767.98px) {
		grid-auto-columns: 326px;
		grid-template-rows: 1fr 52px;
		div > button {
			padding: 0 24px;
			font-size: 14px;
			line-height: 20px;
		}
		svg {
			top: 16px;
			right: 16px;
		}
	}
`;
const ContentVerticalCenter = styled.div`
	width: 100%;
	max-width: 1352px;
	height: 100%;
	padding: 0 16px;

	display: flex;
	flex-direction: column;
	align-items: center;

	@media only screen and (min-width: 768px) {
		align-items: flex-start;
		justify-content: center;
	}

	@media only screen and (max-width: 767.98px) {
		max-width: none;
		padding: 0;
	}
`;

const TopCarousel = styled.div`
	display: flex;
	justify-content: center;

	width: 100%;
	height: 660px;
	background-image: url(${TopBackgroundImg});
	background-position: center;
	background-size: cover;

	@media only screen and (max-width: 767.98px) {
		height: 500px;
		background-image: url(${MobileTopBackgroundImg});
	}
`;

const TopCarouselTitle = styled.div`
	color: white;

	@media only screen and (min-width: 768px) {
		margin-left: 148px;
		font-size: 42px;
		font-weight: 700;
		line-height: 62px;
	}

	@media only screen and (max-width: 767.98px) {
		text-align: center;
		margin-top: 173px;
		font-size: 24px;
		font-weight: 700;
		line-height: 36px;
	}
`;

const MobileTopButtonContainer = styled.div`
	margin-top: 20px;
	display: flex;
`;

const ServiceButton = styled.div`
	width: 98px;
	height: 42px;

	display: flex;
	align-items: center;
	justify-content: center;

	background-color: white;
	box-sizing: border-box;
	box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.1);
	border-radius: 5px;
	cursor: pointer;

	& + & {
		margin-left: 20px;
	}
`;

const ServiceLogo = styled.img`
	width: 70px;
	height: auto;
`;

const Row = styled.div`
	width: 100%;
	display: flex;

	${(props) =>
		props.flexDirection &&
		css`
			flex-direction: ${props.flexDirection};
		`}

	@media only screen and (min-width: 768px) {
		& + & {
			margin-top: 130px;
		}
	}

	@media only screen and (max-width: 767.98px) {
		& + & {
			margin-top: 60px;
		}
	}
`;

const Column = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;

	${(props) =>
		props.paddingLeft &&
		css`
			padding-left: ${props.paddingLeft};
		`}

	@media only screen and (min-width: 768px) {
		width: 50%;
	}

	@media only screen and (max-width: 767.98px) {
		width: 100%;
		align-items: center;
	}
`;

const PreviewReviewAid = styled.img`
	@media only screen and (min-width: 768px) {
		width: 100%;
		max-width: 580px;
		height: auto;
		filter: drop-shadow(2px 3px 25px rgba(0, 0, 0, 0.1));
		border-radius: 10px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 20px;
		width: 100%;
		max-width: 300px;
		height: auto;
		filter: drop-shadow(2px 3px 25px rgba(0, 0, 0, 0.1));
		border-radius: 5px;
	}
`;

const PreviewAtsent = styled.img`
	@media only screen and (min-width: 768px) {
		width: 100%;
		max-width: 600px;
		height: auto;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 20px;
		width: 100%;
		max-width: 280px;
		height: auto;
		filter: drop-shadow(2px 3px 25px rgba(0, 0, 0, 0.1));
		border-radius: 5px;
	}
`;

const SubTitle = styled.span`
	@media only screen and (min-width: 768px) {
		font-size: 32px;
		font-weight: 700;
		line-height: 32px;
	}

	@media only screen and (max-width: 767.98px) {
		text-align: center;
		font-size: 18px;
		font-weight: 700;
		line-height: 18px;
	}
`;

const Description = styled.span`
	@media only screen and (min-width: 768px) {
		margin-top: 26px;
		font-size: 20px;
		font-weight: 400;
		line-height: 30px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 20px;
		text-align: center;
		font-size: 14px;
		font-weight: 400;
		line-height: 24px;
	}
`;

const More = styled.span`
	cursor: pointer;

	@media only screen and (min-width: 768px) {
		margin-top: 30px;
		font-size: 22px;
		font-weight: 700;
		line-height: 22px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 10px;
		text-align: center;
		font-size: 14px;
		font-weight: 700;
		line-height: 14px;
		a {
			color: #4ba4f8;
		}
	}
`;

const OnMyDevCardContainer = styled.div`
	display: flex;
	justify-content: center;

	@media only screen and (min-width: 768px) {
		margin-top: 100px;
		flex-wrap: wrap;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 30px;
		flex-direction: column;
	}
`;

const Card = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: white;

	box-shadow: 2px 3px 25px rgba(0, 0, 0, 0.1);
	border-radius: 10px;

	${(props) =>
		props.large &&
		css`
			@media only screen and (min-width: 768px) {
				width: 320px;
				height: 350px;
				margin: 0 60px 60px 60px;
			}

			@media only screen and (max-width: 767.98px) {
				width: 280px;
				height: auto;
				padding: 40px 0;
				:not(:first-child) {
					margin-top: 20px;
				}
			}
		`}

	${(props) =>
		props.small &&
		css`
			@media only screen and (min-width: 768px) {
				width: 240px;
				height: 100px;
				margin: 0 7px 30px 7px;
			}

			@media only screen and (max-width: 767.98px) {
				width: 137px;
				height: 70px;
				:not(:first-child) {
					margin-left: 20px;
				}
			}
		`}
`;

const CardIcon = styled.span`
	@media only screen and (min-width: 768px) {
		font-size: 40px;
		font-weight: 700;
		line-height: 48px;
	}

	@media only screen and (max-width: 767.98px) {
		font-size: 24px;
		font-weight: 700;
		line-height: 24px;
	}
`;

const CardTitle = styled.span`
	@media only screen and (min-width: 768px) {
		margin-top: 30px;
		font-size: 32px;
		font-weight: 700;
		line-height: 32px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 20px;
		font-size: 22px;
		font-weight: 700;
		line-height: 18px;
	}
`;

const CardSubTitle = styled.span`
	@media only screen and (min-width: 768px) {
		margin-top: 16px;
		font-size: 20px;
		font-weight: 700;
		line-height: 20px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 12px;
		font-size: 16px;
		font-weight: 700;
		line-height: 16px;
	}
`;

const CardDescription = styled.span`
	@media only screen and (min-width: 768px) {
		margin-top: 30px;
		min-height: 90px;
		text-align: center;
		font-size: 20px;
		font-weight: 400;
		line-height: 30px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 20px;
		text-align: center;
		font-size: 14px;
		font-weight: 400;
		line-height: 24px;
	}
`;

const PartnerCardContainer = styled.div`
	display: flex;
	justify-content: center;

	@media only screen and (min-width: 768px) {
		margin-top: 80px;
		flex-wrap: wrap;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 30px;
		flex-direction: column;
	}
`;

const PartnerLogo = styled.img`
	@media only screen and (min-width: 768px) {
		width: 160px;
		height: auto;
	}

	@media only screen and (max-width: 767.98px) {
		width: 90px;
		height: auto;
	}
`;

const MobileCardRow = styled.div`
	display: flex;
	& + & {
		margin-top: 20px;
	}
`;

export default Main;
